import { OrderSet } from '@exodus/models';
const resultFunction = (orders = OrderSet.EMPTY, availableAssets, walletAccounts) => {
    const relevant = [...orders].filter((order) => {
        if (!order.fromAsset || !order.toAsset)
            return false;
        const availableAsset = availableAssets[order.fromAsset] && availableAssets[order.toAsset];
        const enabledWalletAccount = walletAccounts.includes(order.fromWalletAccount ?? '') ||
            walletAccounts.includes(order.toWalletAccount ?? '');
        return availableAsset && enabledWalletAccount;
    });
    return OrderSet.fromArray(relevant);
};
const allOrdersSelectorDefinition = {
    id: 'all',
    resultFunction,
    dependencies: [
        { selector: 'data' },
        { module: 'availableAssets', selector: 'all' },
        { module: 'walletAccounts', selector: 'enabled' },
    ],
};
export default allOrdersSelectorDefinition;
